import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOwaspComponent } from './simple-icons-owasp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOwaspComponent ],
    exports:      [ SimpleIconsOwaspComponent ],
    bootstrap:    []
})
export class SimpleIconsOwaspModule {}
